 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"assist-main~classes~community~member~teacher-main":"assist-main~classes~community~member~teacher-main","assist-main~community~teacher-main":"assist-main~community~teacher-main","community":"community","classes~course~package~periods":"classes~course~package~periods","classes~member~periods":"classes~member~periods","classes~course~member":"classes~course~member","classes":"classes","integral~member~order":"integral~member~order","member":"member","assist-main~member-exam~teacher-main":"assist-main~member-exam~teacher-main","member-exam":"member-exam","book":"book","periods":"periods","common~course~index~oto":"common~course~index~oto","course":"course","package":"package","common-component":"common-component","common~oto":"common~oto","common":"common","oto":"oto","index":"index","custom-page":"custom-page","download":"download","download-client":"download-client","exam~homework":"exam~homework","exam":"exam","homework":"homework","integral":"integral","order":"order","library":"library","live":"live","login":"login","news":"news","regist-information":"regist-information"}[chunkId]||chunkId) + "." + {"assist-main~classes~community~member~teacher-main":"68651fb5","assist-main~community~teacher-main":"82119868","community":"b7d1d36d","classes~course~package~periods":"d7a75155","classes~member~periods":"9e587f42","classes~course~member":"5072ecda","classes":"6e592f5f","integral~member~order":"22ac199f","member":"e0e97127","assist-main~member-exam~teacher-main":"92b1689a","member-exam":"c37702cd","book":"66822f84","chunk-a8c36ef4":"82210e6f","periods":"9f370aa0","common~course~index~oto":"f44390bd","course":"9fe107a8","package":"0371c777","common-component":"c46a1098","common~oto":"5cb552d3","common":"7839ce7f","oto":"1d0cfbdf","index":"914863b6","custom-page":"28ac6797","download":"d7971620","download-client":"d91d3c7e","exam~homework":"525df7c9","exam":"7b38987d","homework":"de8bcc8c","integral":"bc4d033e","order":"6484d797","library":"c9b98870","live":"9a9ee81e","login":"962c622f","news":"250c0892","regist-information":"84b1a50f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"assist-main~classes~community~member~teacher-main":1,"assist-main~community~teacher-main":1,"community":1,"classes~course~package~periods":1,"classes~member~periods":1,"classes~course~member":1,"classes":1,"integral~member~order":1,"member":1,"assist-main~member-exam~teacher-main":1,"member-exam":1,"book":1,"chunk-a8c36ef4":1,"periods":1,"common~course~index~oto":1,"course":1,"package":1,"common-component":1,"common~oto":1,"common":1,"oto":1,"index":1,"download":1,"download-client":1,"exam~homework":1,"exam":1,"homework":1,"integral":1,"order":1,"library":1,"live":1,"login":1,"news":1,"regist-information":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"assist-main~classes~community~member~teacher-main":"assist-main~classes~community~member~teacher-main","assist-main~community~teacher-main":"assist-main~community~teacher-main","community":"community","classes~course~package~periods":"classes~course~package~periods","classes~member~periods":"classes~member~periods","classes~course~member":"classes~course~member","classes":"classes","integral~member~order":"integral~member~order","member":"member","assist-main~member-exam~teacher-main":"assist-main~member-exam~teacher-main","member-exam":"member-exam","book":"book","periods":"periods","common~course~index~oto":"common~course~index~oto","course":"course","package":"package","common-component":"common-component","common~oto":"common~oto","common":"common","oto":"oto","index":"index","custom-page":"custom-page","download":"download","download-client":"download-client","exam~homework":"exam~homework","exam":"exam","homework":"homework","integral":"integral","order":"order","library":"library","live":"live","login":"login","news":"news","regist-information":"regist-information"}[chunkId]||chunkId) + "." + {"assist-main~classes~community~member~teacher-main":"72b26323","assist-main~community~teacher-main":"70ccb8d9","community":"b583fb39","classes~course~package~periods":"3fd45b40","classes~member~periods":"a3924ac0","classes~course~member":"f69b750a","classes":"a9ac76fd","integral~member~order":"8f35ae79","member":"0d0402ce","assist-main~member-exam~teacher-main":"1337f147","member-exam":"9677a85e","book":"375a9561","chunk-a8c36ef4":"30b498a5","periods":"46476ac8","common~course~index~oto":"02cfeeac","course":"1fcf4636","package":"4f5d66a7","common-component":"359815b1","common~oto":"3d1f2863","common":"b21f99a0","oto":"bbd052ad","index":"dea9aee7","custom-page":"31d6cfe0","download":"c63d79b0","download-client":"ae89259b","exam~homework":"37558d03","exam":"6c459dda","homework":"40cd64b5","integral":"e716c69e","order":"80be34c4","library":"0dae8cd7","live":"22b37371","login":"1ab85836","news":"8e3359a8","regist-information":"e5eb1589"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/pc/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
